<template>
    <div>
        <!--[if lt IE 7]>
        <p class="alert alert-danger">You are using an <strong>outdated</strong> browser. Please <a
            href="http://browsehappy.com/">upgrade your browser</a> to improve your experience.</p>
        <![endif]-->
        <Header/>
        <Menu/>
        <slot/>
    </div>
</template>

<script>

    import Header from '../common/Header.vue'
    import Menu from '../common/Menu.vue'


    export default {
        components: {
            Header,
            Menu,
        },
        methods: {},
        mounted: function () {
            document.body.className += " header_pasarela";
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/layouts/UserLayout.vue